detail-header<template>
  <div class="detail">
    <!-- 顶部标题区 -->
    <div class="detail-header">
      <div class="detail-header-text">
        <h3>项目详情</h3>
        <p>随时随地为您提供智能的解决方案</p>
      </div>
    </div>

    <!-- 内容主体区 -->
    <div class="detail-background">
      <div class="detail-content">
        <!-- 核心信息卡片 -->
        <div class="detail-content-top">
          <div class="detail-content-top-left">
            <img src="../assets/default.png" alt="创建人头像">
            <span>{{ruleForm.creatorName}}</span>
          </div>
          
          <div class="detail-content-top-right">
            <h1 class="project-type">{{ruleForm.type == 1?'广告策划':ruleForm.type == 2?'企业咨询':ruleForm.type == 3?"数字内容制作":"系统平台搭建"}}</h1>
            
            <div class="info-item">
              <h2>项目名称</h2>
              <span>{{ruleForm.projectName}}</span>
            </div>

            <div class="info-item">
              <h3>项目描述</h3>
              <span class="desc-text">{{ruleForm.projectDescribe}}</span>
            </div>

            <div class="info-row">
              <div class="info-item">
                <p>项目预算</p>
                <span class="highlight">{{ruleForm.projectSpendStr}}</span>
              </div>
              <div class="info-item">
                <p>交付周期</p>
                <span class="highlight">{{ruleForm.expectDay}}天</span>
              </div>
            </div>

            <div class="info-row">
              <div class="info-item">
                <p>联系人</p>
                <span>{{ruleForm.contacts}}</span>
              </div>
              <div class="info-item">
                <p>联系方式</p>
                <span>{{ruleForm.contactPhone}}</span>
              </div>
            </div>

            <div class="info-item">
              <h4>联系地址</h4>
              <span>{{ruleForm.contactAdd}}</span>
            </div>
          </div>
        </div>

        <!-- 图片分割线 -->
        <em v-if="ruleForm.proPicList.length > 0"></em>

        <!-- 项目图片列表 -->
        <div class="detail-content-imgList" v-if="ruleForm.proPicList.length > 0">
          <div class="img-item" v-for="(item,index) in ruleForm.proPicList" :key="index">
            <img :src="item" alt="项目图片">
            <span class="mask">
              <img
                src="../assets/zoom.png"
                class="zoom-icon"
                @click="previewUrl = item,previewDia = true"
              >	
            </span>      
          </div>
        </div>

        <!-- 返回按钮 -->
        <div class="back-btn" @click="$router.go(-1)">返回</div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog
      title=""
      custom-class="preview-dialog"
      :visible.sync="previewDia"
      width="800px"
      append-to-body
    >
      <img :src="previewUrl" alt="预览图" style="width:100%;height:100%;border-radius: 6px;">
    </el-dialog>
  </div>
</template>

<script>
import { getDetail } from "../utils/publish"
export default {
  name: 'ProjectDetail', 
  components: {},
  data(){
    return{
      ruleForm: {
        proPicList:[]
      },
      previewDia:false,
      previewUrl:"",
      rules: {
        type: [
          { required: true, message: '请选择项目类型', trigger: 'change' },
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        projectSpend: [
          { required: true, message: '请选择预算范围', trigger: 'change' },
        ],
        projectDescribe: [
          { required: true, message: '请输入项目描述', trigger: 'blur' },
        ],
        expectDay: [
          { required: true, message: '请输入期望交付周期', trigger: 'blur' },
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
      },
      options:[
        { label:"3万以下", value:"1" },
        { label:"3万-10万", value:"2" },
        { label:"10万-50万", value:"3" },
        { label:"50万以上", value:"4" },
      ],
      options2:[
        { label:"广告策划", value:1 },
        { label:"企业咨询", value:2 },
        { label:"数字内容制作", value:3 },
        { label:"系统平台搭建", value:4 },
      ]
    }
  },
  methods:{},
  activated(){
    if(this.$route.query.id){
      getDetail({id:this.$route.query.id}).then(res => {
        if(res.data.code == 200 ){
          this.$nextTick(()=>{
            this.ruleForm = res.data.data
          })
        }else{
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
// 全局颜色变量（匹配参考图深色+金色主题）
@main-bg: #232730;
@card-bg: #17191F;
@border-color: rgba(212, 175, 55, 0.6);
@highlight-color: #F8D030;
@main-text: #FFFFFF;
@sub-text: #B0B0B0;
@mask-bg: rgba(0, 0, 0, 0.7);
@btn-bg: #D4AF37;
@btn-hover: #F8D030;

// 通用mixin
.flex-center() {
  display: flex;
  align-items: center;
  justify-content: center;
}
.font-main(@size, @weight) {
  font-size: @size;
  font-family: 'PingFangSC,PingFang SC', 'AlibabaPuHuiTi_2_75_SemiBold', sans-serif;
  font-weight: @weight;
  color: @main-text;
}
.font-sub(@size, @weight) {
  font-size: @size;
  font-family: 'PingFangSC,PingFang SC', 'AlibabaPuHuiTi_2_75_SemiBold', sans-serif;
  font-weight: @weight;
  color: @sub-text;
}

// 页面根容器
.detail {
  width: 100%;
  min-height: 100vh;
  background-color: @main-bg;
  overflow-x: hidden;

  // 顶部标题栏
  &-header {
    width: 100%;
    height: 320px;
    background: linear-gradient(180deg, rgba(23,25,31,0.9) 0%, rgba(23,25,31,0.5) 100%);
    // display: flex;
    // align-items: center;
    // justify-items: center;
    padding-top: 100px;

    &-text {
      margin-left: 120px;
      h3 {
        .font-main(48px, 600);
        margin: 0;
        text-align: left;
      }
      p {
        .font-sub(28px, 400);
        margin: 16px 0 0;
        max-width: 700px;
        line-height: 40px;
        text-align: left;
      }
    }
  }

  // 内容背景区
  &-background {
    width: 100%;
    background: @main-bg;
    padding: 80px 0 80px;
  }

  // 核心内容卡片
  &-content {
    width: 1400px;
    background: @card-bg;
    box-sizing: border-box;
    padding: 60px 80px;
    margin: -100px auto 0;
    border-radius: 12px;
    border: 1px solid @border-color;
    position: relative;
    z-index: 9;
    box-shadow: 0 8px 32px rgba(0,0,0,0.4);

    // 顶部信息布局
    &-top {
      display: flex;
      align-items: flex-start;
      gap: 60px;

      // 左侧创建人信息
      &-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        img {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 2px solid @border-color;
          margin-bottom: 12px;
          object-fit: cover;
        }
        span {
          .font-main(22px, 600);
        }
      }

      // 右侧项目详情
      &-right {
        width: 100%;
        text-align: left;

        .project-type {
          .font-main(32px, 600);
          margin: 0 0 32px;
          color: @highlight-color;
        }

        // 单行信息项
        .info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 24px;
          gap: 16px;

          h2,h3,h4,p {
            .font-main(24px, 600);
            min-width: 140px;
            margin: 0;
            flex-shrink: 0;
          }

          span {
            .font-sub(24px, 400);
            line-height: 36px;
            word-break: break-all;
          }

          .desc-text {
            line-height: 38px;
          }

          .highlight {
            color: @highlight-color;
            font-weight: 600;
          }
        }

        // 双列信息行
        .info-row {
          display: flex;
          align-items: flex-start;
          gap: 80px;
          margin-bottom: 24px;

          .info-item {
            width: 50%;
            margin-bottom: 0;
          }
        }
      }
    }

    // 分割线
    em {
      width: 100%;
      height: 1px;
      background: rgba(255,255,255,0.1);
      display: block;
      margin: 48px 0 32px;
      font-style: normal;
    }

    // 图片列表
    &-imgList {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      gap: 1.333%;
      row-gap: 20px;

      .img-item {
        width: 24%;
        height: 180px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        border: 1px solid rgba(255,255,255,0.1);

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          .flex-center();
          opacity: 0;
          background-color: @mask-bg;
          transition: opacity .3s ease;
          cursor: pointer;

          .zoom-icon {
            width: 36px;
            height: 36px;
          }
        }

        &:hover .mask {
          opacity: 1;
        }
      }
    }

    // 返回按钮
    .back-btn {
      width: 220px;
      height: 56px;
      background: @btn-bg;
      border-radius: 8px;
      margin: 60px auto 0;
      .font-main(20px, 500);
      line-height: 56px;
      text-align: center;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        background: @btn-hover;
        box-shadow: 0 0 16px rgba(248, 208, 48, 0.4);
        transform: translateY(-2px);
      }
    }
  }
}

// 弹窗深色样式（深度选择器覆盖Element默认样式）
:deep(.preview-dialog) {
  background: @card-bg;
  border-radius: 12px;
  border: 1px solid @border-color;

  .el-dialog__header {
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 16px 20px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: @sub-text;
    font-size: 20px;

    &:hover {
      color: @main-text;
    }
  }

  .el-dialog__body {
    padding: 20px;
    background: @card-bg;
  }
}
</style>